import DealUtils from 'arbitrip-common/client/entities/DealUtils';

const dealSupplierExtractor = DealUtils.dealSupplierExtractor;
const isValidDeal = DealUtils.isValidDeal;
const isValidRecheck = DealUtils.isValidRecheck;
const updateDealRecheck = DealUtils.updateDealRecheck;
const createDeal = DealUtils.createDeal;
const createDeals = DealUtils.createDeals;

export default {
    dealSupplierExtractor,
    isValidDeal,
    isValidRecheck,
    createDeal,
    createDeals,
    updateDealRecheck,
};
